import React from "react";
import Navbars from "../Pages/Navbar/Navbar";
import ScrollToTop from "../Pages/ScrollTop";
import Footer from "../Pages/Footer/Footer";

export default function ReturnPolicy() {
  return (
    <div>
      <Navbars />
      <ScrollToTop />
      <div
        style={{ backgroundColor: "#050810", color: "white" }}
        className="Homemargin"
      >
        <div
          className="d-flex p-4"
          style={{
            justifyContent: "center",
            alignItems: "center",
            fontFamily: "NunitoBlack",
          }}
        >
          <p style={{ color: "#f9c130", fontSize: "30px" }}>Return Policy</p>
        </div>
        <div
          className="container"
          style={{ lineHeight: 2, fontFamily: "JosefinSans", fontSize: "18px" }}
        >
          <div class="page" title="Page 11">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  {/* <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    15. Refunds and Cancellations:
                  </p> */}
                  <p>
                    If there is an error in the Services we provide (at our
                    discretion), we may issue a refund if genuine reasons are
                    proven after investigation.
                  </p>
                  <p>
                    Please carefully read the rules of each Game and Contest
                    before participating.
                  </p>
                  <p>
                    Registrations cannot be canceled once entered, but in
                    exceptional circumstances where the fault lies with us, we
                    will cancel your participation upon request and refund the
                    in-app virtual currency entry fee within a reasonable
                    timeframe.
                  </p>
                  <p>
                    If we cancel your participation in a Game or Contest, we
                    will return your in-app virtual currency entry fee amount to
                    your relevant wallet (Deposit/Bonus) within a reasonable
                    timeframe for you to use it in other Contests.
                  </p>
                  <p>
                    Refunds will be made to the same account used for the
                    initial payment.
                  </p>
                  <p>
                    All amounts credited to the Winnings Wallet or deposited in
                    the Deposit Wallet must be utilized within 365 days.
                    Unutilized amounts after 365 days will no longer be usable,
                    and we are not liable to provide compensation.
                  </p>
                  <p>
                    We are not liable for services provided by third parties on
                    our Application, including downtimes, network failures,
                    glitches, payment failures, and delays on their end.
                  </p>
                  <p>
                    You are responsible for complying with the terms and
                    conditions of relevant third-party payment gateway
                    providers, including their KYC requirements for deposits and
                    withdrawals.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
